export const NAME = 'user';
export const NON_ZIP_COUNTRIES = [
    'AO',
    'AE',
    'AG',
    'BI',
    'BJ',
    'BF',
    'BS',
    'BZ',
    'BO',
    'CF',
    'CL',
    'CM',
    'CD',
    'KM',
    'DJ',
    'DM',
    'ER',
    'ET',
    'FJ',
    'GA',
    'GM',
    'GQ',
    'GD',
    'GY',
    'HK',
    'KI',
    'KN',
    'LC',
    'ML',
    'MR',
    'MW',
    'NR',
    'QA',
    'RW',
    'SL',
    'SO',
    'ST',
    'SR',
    'SC',
    'TD',
    'TG',
    'TO',
    'TT',
    'TV',
    'UG',
    'VU',
    'YE',
    'ZW',
];
